 import MainLayout from '../layouts/MainLayout';

const routes = [
    {
        path: '/employees',
        meta: {role: 'ADMIN', layout: MainLayout, name: 'Сотрудники'},
        children: [
            {
                path: '',
                name: 'Employees',
                component: () => import('../views/employees'),
            },
            {
                path: 'new',
                name: 'NewEmployee',
                meta: {name: 'Новый доступ'},
                component: () => import('../views/createEmployee'),
            },
            {
                path: 'edit/:employeeId',
                name: 'Edit',
                meta: {name: 'Редактировать доступ'},
                component: () => import('../views/createEmployee'),
            },
        ]
    },
    {
        path: '/settings',
        name: 'Settings',
        meta: {role: 'ADMIN', layout: MainLayout},
        component: () => import('../views/settings')
    },
    {
        path: '/account-integrations',
        name: 'Account integrations',
        meta: { role: 'ADMIN', layout: MainLayout },
        component: () => import('../views/accountIntegrations')
    },
    {
        path: '/analytics',
        meta: {role: 'HR', layout: MainLayout, name: 'Аналитика'},
        children: [
            {
                path: '',
                name: 'AnalyticsList',
                component: () => import('../views/analytics'),
            },
            // {
            //     path: ':id',
            //     name: 'ResponseCard',
            //     meta: {name: 'Карточка отклика'},
            //     component: () => import('../views/response'),
            // }
        ]
    },
    {
        path: '/legal-entities',
        name: 'Legal entities',
        meta: {role: 'ADMIN', layout: MainLayout},
        component: () => import('../views/LegalEntities.vue')
    },
    {
        path: '/sources',
        name: 'Sources',
        meta: {role: 'ADMIN', layout: MainLayout},
        component: () => import('../views/Sources.vue')
    },
    {
        path: '/divisions',
        name: 'Divisions',
        meta: {role: 'ADMIN', layout: MainLayout},
        component: () => import('../views/Divisions.vue')
    },
    {
        path: '/positions',
        name: 'Positions',
        meta: {role: 'ADMIN', layout: MainLayout},
        component: () => import('../views/Positions.vue')
    },
]

export default routes
